module.exports = __webpack_public_path__ + "img/hr-tree-01-h-trunk.abf30fca.png";